<template>

    <m-edit1/>

    <m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-nav-508 v-bind='{...{"hideDashboardLink":true,"megaMenuPosition":"store_nav","megaMenuTitle":"\u0645\u0646\u0648","hamburgerMenuPosition":"store_nav","hamburgerMenuTitle":"\u0645\u0646\u0648","imageInsideSearchProp":"","showProfileLoginName":false,"dashboardLink":"","searchDirectPage":"search","hideShoppingCart":false,"menuPosition":"blog_nav","searchInput":"mSearchInput200"},...{}}' :style='""' class="" >
                <template #default>   <m-nav-sidebar-502 v-bind='{...{"menuPosition":"blog_nav","buttonText":""},...{}}' :style='""' class="d-inline-block" >
                <template #default>   <m-search-input-2 v-bind='{...{"directPage":"search"},...{}}' :style='""' class="" ></m-search-input-2></template>
                </m-nav-sidebar-502><m-span v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="d-inline-block mx-1" >
                <template #default>منو   </template>
                </m-p></template>
                </m-span></template>
                
                <template #consult>   </template>
                
                <template #register>   </template>
                </m-nav-508></template>
                </m-div><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='""' class=" rounded shadow container-fluid mt-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row text-center py-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-4 col-sm-6 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.omidnoorani.ir\/storage\/icons\/tig6QWBiYyuJJ12N6UKioXqP1MjqHQnNB5JaFwWL-1782124161.png","alt":"omidnoorani"},...{}}' :style='"width:150px"' class="img-fluid" ></m-img><m-p v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>برای موفقیت در کنکور، هم امتحانات نهایی و هم آزمون سراسری رو باید بترکونی! همه‌ی این مسیر هم با درس ریاضی درگیر هستی! هدف ما کسب نمرات خوب و درصد عالی هست و این جز با یادگیری مفهومی، آموزش تستی و تشریحی، بررسی نمونه سوالات و روش تدریس مناسب قابل حل نیست.
اینجا همون جایی هست که کاملا همراه شماست تا موفقیت!   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-sm-6" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='"font-size:14px"' class="my-3" >
                <template #default>پایه ها:
   </template>
                </m-h4><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>دهم   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>یازدهم   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>دوازدهم   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-sm-6" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='"font-size:14px"' class="my-3" >
                <template #default>مدرسه ریاضیات   </template>
                </m-h4><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>دوره‌های آموزشی آنلاین
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>آزمون‌های آزمايشي
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>کارگاه‌های مرور و جمع‌بندی
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>بانک سوال و تخته نوشت‌ها
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>کتاب و جزوه
   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-sm-6" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='"font-size:14px"' class="my-3" >
                <template #default>مشاوره و پشتیبانی:
   </template>
                </m-h4><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>مسیر یادگیری
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>راز موفقیت
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>اهمیت ریاضی
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>بانک سوال و تخته نوشت‌ها
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>کتاب و جزوه
   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-sm-6" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='"font-size:14px"' class="my-3" >
                <template #default>مشاوره و پشتیبانی:
   </template>
                </m-h4><m-a v-bind='{...{"href":"{\"name\":\"aboutUS\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="d-block my-2" >
                <template #default>درباره‌‌ی ما
   </template>
                </m-a><m-a v-bind='{...{"href":"{\"name\":\"contactus\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="d-block my-2" >
                <template #default>تماس با ما
   </template>
                </m-a><m-a v-bind='{...{"href":"{\"name\":\"hamkari\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="d-block my-2" >
                <template #default>همکاری با ما
   </template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col bg-primar" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:30px;padding:35px;"' class="col-12 my-4 bg-primary d-flex justify-content-between align-items-center flex-wrap" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="d-flex align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"width:56px;height:56px;background:#f5c518;border-radius:50%;"' class="d-flex align-items-center justify-content-center ml-3" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.omidnoorani.ir\/storage\/icons\/iphone.png","alt":"omidnoorani"},...{}}' :style='"height:28px;"' class="" ></m-img></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="text-right" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='"color:#f5c518;"' class="mb-1 font-weight-bold" >
                <template #default>شبکه‌های اجتماعی   </template>
                </m-h4><m-p v-bind='{...{},...{}}' :style='""' class="mb-1 text-white " >
                <template #default>ما را دنبال کنید   </template>
                </m-p><m-a v-bind='{...{"href":"tel:09163025636","target":"_self"},...{}}' :style='""' class="text-white mx-1" >
                <template #default>09163025636   </template>
                </m-a><m-a v-bind='{...{"href":"tel:06133385856","target":"_self"},...{}}' :style='""' class="text-white" >
                <template #default>06133385856   </template>
                </m-a></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="d-flex align-items-center flex-wrap" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/eitaa.com\/nooraniomid_math","target":"_self"},...{}}' :style='"width:48px;height:48px;"' class="d-inline-flex align-items-center justify-content-center bg-white rounded mx-1" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.omidnoorani.ir\/storage\/icons\/site-logo-larg.png","alt":"\u0627\u06cc\u062a\u0627"},...{}}' :style='"height:28px;"' class="" ></m-img></template>
                </m-a><m-a v-bind='{...{"href":"https:\/\/ble.ir\/nooraniomid","target":"_self"},...{}}' :style='"width:48px;height:48px;"' class="d-inline-flex align-items-center justify-content-center bg-white rounded mx-1" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.omidnoorani.ir\/storage\/icons\/bale (\u0631\u0633\u0627\u0646\u06cc\u06a9\u0627).png","alt":"\u0628\u0644\u0647"},...{}}' :style='"height:28px;"' class="" ></m-img></template>
                </m-a><m-a v-bind='{...{"href":"https:\/\/t.me\/riazi10","target":"_self"},...{}}' :style='"width:48px;height:48px;"' class="d-inline-flex align-items-center justify-content-center bg-white rounded mx-1" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.omidnoorani.ir\/storage\/icons\/-logo-telegram.png","alt":"\u062a\u0644\u06af\u0631\u0627\u0645"},...{}}' :style='"height:28px;"' class="" ></m-img></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-hr v-bind='{...{},...{}}' :style='""' class="" ></m-hr></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6 text-dark" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/mixitweb.com","target":"_self"},...{}}' :style='""' class="text-dark" >
                <template #default>ساخته شده با  ❤ توسط mixitweb   </template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_blank"},...{}}' :style='""' class="text-primary" >
                <template #default>تمام حقوق برای امید نورانی محفوظ است .   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav508 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav508/Nav508'; import mNavSidebar502 from '@moeinmdn/miw-alpha-components/src/package/Navs/NavSidebar502/NavSidebar502'; import mSearchInput2 from '@moeinmdn/miw-alpha-components/src/package/Search/Input/SearchInput2'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mHr from '@moeinmdn/miw-alpha-components/src/package/Tags/Hr';

export default {
    name: 'HomeView',
    components: {mEdit1, mUpdateSiteMessage1,mLoading3,mDiv,mNav508,mNavSidebar502,mSearchInput2,mSpan,mP,mImg,mH4,mA,mHr },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
